var map = {
	"./bell.svg": 8358,
	"./bookicon.svg": 4888,
	"./bookicon2.svg": 3766,
	"./certificate.svg": 3046,
	"./dashboard.svg": 8749,
	"./draw.svg": 6829,
	"./earth.svg": 5759,
	"./error.svg": 3884,
	"./faceicon.svg": 2781,
	"./faceicon2.svg": 6004,
	"./figureicon.svg": 9108,
	"./friend.svg": 978,
	"./gear.svg": 2084,
	"./honeycomb.svg": 842,
	"./izidatalogo.svg": 8111,
	"./navicon.svg": 8513,
	"./ocricon.svg": 6633,
	"./phone.svg": 5522,
	"./printer.svg": 2225,
	"./redbag.svg": 2117,
	"./searchicon.svg": 5128,
	"./shield.svg": 4189,
	"./shujuicon.svg": 1541,
	"./tanx.svg": 6385,
	"./token.svg": 3586,
	"./upload.svg": 9794,
	"./vague.svg": 3894,
	"./wallet.svg": 9854,
	"./whiteboard.svg": 2401,
	"./xinxiicon.svg": 6875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;